import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-lti-header-panel',
  template: '<ng-content />',
  styleUrls: ['lti-header-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LtiHeaderPanelComponent {
}
